<template>
    <div class="container">
        <div class="search pet-search">
            <el-form :inline="true" :model="search" size="small">
                <el-form-item>
                    <el-input v-model.trim="search.kname" clearable placeholder="套餐名称" @keyup.enter="handleSearch"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model.trim="search.code" clearable placeholder="套餐编号" @keyup.enter="handleSearch"></el-input>
                </el-form-item>
                <el-form-item>
                    <SearchInnerModel v-model="search.product_model_code" placeholder="选择产品型号" style="width: 200px"></SearchInnerModel>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="search.status" multiple collapse-tags clearable placeholder="套餐状态" @change="handleSearch">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch">查询</el-button>
                    <el-button @click="resetSearch">重置</el-button>
                </el-form-item>
            </el-form>
            <div class="toolbar">
                <router-link to="/iot/petpack/cloudinfo">
                    <el-button size="small">后台开通/关闭</el-button>
                </router-link>
                <router-link to="/iot/petpack/create">
                    <el-button type="primary" size="small">新建套餐</el-button>
                </router-link>
            </div>
        </div>

        <el-table v-loading="loading" border :data="list" size="small" @sort-change="handleSort">
            <el-table-column prop="name" label="套餐名称" sortable="custom" min-width="160"></el-table-column>
            <el-table-column prop="code" label="套餐编号" min-width="260"></el-table-column>
            <el-table-column label="设备型号" min-width="160">
                <template v-slot="scope">
                    <span v-if="(scope.row.product_models || []).length">{{ scope.row.product_models.join(', ') }}</span>
                    <el-tag v-else type="danger" size="mini">未关联型号</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="时长" prop="time" sortable="custom" width="110">
                <template v-slot="scope">{{ scope.row.time }} {{ scope.row.time_unit }}</template>
            </el-table-column>
            <el-table-column label="扣款周期" width="90">
                <template v-slot="scope">{{ scope.row.cycles === 0 ? '无限' : scope.row.cycles }}</template>
            </el-table-column>
            <el-table-column label="试用天数" width="90">
                <template v-slot="scope">{{ scope.row.trial_days > 0 ? scope.row.trial_days + ' 天' : '-' }}</template>
            </el-table-column>
            <el-table-column label="价格（售价/原价）" min-width="180">
                <template v-slot="scope">
                    <div v-for="price in scope.row.prices || []" :key="price.currency"
                        :class="{ 'price-off': price.status === 0 }">
                        {{ price.currency }} {{ price.sale_price }} / <s>{{ price.price }}</s>
                        <span v-if="price.status === 0">（停售）</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="上架区域" min-width="110">
                <template v-slot="scope">{{ (scope.row.regions || []).join(', ') || '未指定' }}</template>
            </el-table-column>
            <el-table-column label="标签" width="80">
                <template v-slot="scope">{{ tagText(scope.row.tag) }}</template>
            </el-table-column>
            <el-table-column prop="sort_order" label="排序" sortable="custom" width="80"></el-table-column>
            <el-table-column label="状态" width="120">
                <template v-slot="scope">
                    <el-select :model-value="scope.row.status" size="mini" :disabled="statusLoadingCode === scope.row.code"
                        @change="changeStatus(scope.row, $event)">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="90" fixed="right">
                <template v-slot="scope">
                    <router-link :to="'/iot/petpack/detail/' + scope.row.code">
                        <el-button type="primary" size="mini">详情</el-button>
                    </router-link>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination v-model:currentPage="search.page" :page-size="search.limit" :total="total"
            layout="total, prev, pager, next" @current-change="loadList"></el-pagination>
    </div>
</template>

<script>
import api from '../../../axios/pack'
import SearchInnerModel from '../../../components/device/SearchInnerModel.vue'
import { STATUS_OPTIONS, tagText } from './constants'

const defaultSearch = () => ({
    page: 1,
    limit: 20,
    kname: '',
    code: '',
    product_model_code: '',
    status: [0, 1, 2],
    order_field: undefined,
    order_action: undefined
})

export default {
    name: 'PetPackageList',
    components: { SearchInnerModel },
    data() {
        return {
            statusOptions: STATUS_OPTIONS,
            search: defaultSearch(),
            list: [],
            total: 0,
            loading: false,
            statusLoadingCode: ''
        }
    },
    methods: {
        tagText,
        handleSearch() {
            this.search.page = 1
            this.loadList()
        },
        resetSearch() {
            this.search = defaultSearch()
            this.loadList()
        },
        handleSort({ prop, order }) {
            this.search.order_field = order ? prop : undefined
            this.search.order_action = order ? (order === 'descending' ? 2 : 1) : undefined
            this.handleSearch()
        },
        loadList() {
            this.loading = true
            const params = {
                ...this.search,
                kname: this.search.kname || undefined,
                code: this.search.code || undefined,
                product_model_code: this.search.product_model_code || undefined,
                model_action: this.search.product_model_code ? 1 : undefined,
                status: this.search.status.length ? JSON.stringify(this.search.status) : undefined
            }
            api.PetPackageList(params).then(res => {
                if (res.data.code == 200) {
                    this.list = res.data.data.data || []
                    this.total = res.data.data.page_info ? res.data.data.page_info.total : 0
                    return
                }
                this.$message.error('获取失败：' + res.data.msg)
            }).finally(() => {
                this.loading = false
            })
        },
        changeStatus(row, status) {
            const submit = () => {
                this.statusLoadingCode = row.code
                api.PetPackageUpdateStatus({ code: row.code, status }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('状态修改成功')
                        this.loadList()
                        return
                    }
                    this.$message.error('状态修改失败：' + res.data.msg)
                }).finally(() => {
                    this.statusLoadingCode = ''
                })
            }
            const tips = {
                1: '上架后所有用户可见可买，请确认已完成测试账号验收，确定继续?',
                2: '下架后 App 端将不可见，确定继续?',
                3: '删除后套餐将不可见（软删，已购用户不受影响），确定继续?'
            }
            if (tips[status]) {
                this.$confirm(tips[status], '提示', { type: 'warning' }).then(submit).catch(() => {})
                return
            }
            submit()
        }
    },
    created() {
        this.loadList()
    }
}
</script>

<style scoped>
.pet-search { display: flex; justify-content: space-between; align-items: flex-start; }
.toolbar { display: flex; flex-shrink: 0; gap: 8px; }
.price-off { color: #c0c4cc; }
</style>
